import Vue from "vue";

const modulo_proveedores = {
    strict: false,

    state: {
        proveedores: [],
        metodos_pago: [],
        current: 0,
        page: 1,
    },

    getters: {
        getproveedores: (state) => state.proveedores,
    },

    mutations: {
        get_proveedores: (state, proveedores) => {
            state.proveedores = proveedores;
            state.page = 2;
        },
        update_proveedores: (state, proveedores) => {
            state.proveedores = state.proveedores.concat(proveedores.data);
            state.page = proveedores.current_page + 1;
        },
        add_search: (state, proveedores) => {
            state.proveedores = state.proveedores.concat(proveedores);
        },
    },

    actions: {
        getProveedores: (context, vm) => {
            axios.get("api/get-proveedores?amount=15&page=1").then(
                (res) => {
                    context.commit("get_proveedores", res.data.data);
                },
                (res) => {}
            );
        },
        getProveedoresWithId: (context, vm) => {
            axios.get(`api/get-proveedores?amount=15&page=1`).then(
                (res) => {
                    context.commit("get_proveedores", res.data.data);
                },
                (res) => {}
            );
        },
        getProveedoresNext: (context, vm) => {
            axios
                .get(
                    `api/get-proveedores?amount=15&page=${
                        context.state.page ?? 1
                    }`
                )
                .then(
                    (res) => {
                        context.commit("update_proveedores", res.data);
                    },
                    (res) => {}
                );
        },
        searchProveedor: (context, vm) => {
            axios
                .get(
                    `api/get-proveedores?amount=15&page=1${
                        vm ? `&busqueda=${vm}` : ""
                    }`
                )
                .then(
                    (res) => {
                        context.commit("update_proveedores", res.data);
                    },
                    (res) => {}
                );
        },
    },
};

export default modulo_proveedores;
